import React from 'react';
import { useTranslation } from 'react-i18next';
import { propertiesService } from '../../../services/propertiesService';
import { propertyNamesService } from '../../../services/propertyNamesService';
import ListItemTitle from '../../../shared/ListItemTitle';
import { propertyDeleteService } from '../../../services/propertyDeleteService';
import { POPUP_KEY_DELETE_PROPERTY, POPUP_KEY_RESTORE_PROPERTY } from '../../../constant';
import DeleteItemIcon from '../../../shared/DeleteItemIcon';
import RestoreItemIcon from '../../../shared/RestoreItemIcon';
import EditItemIcon from '../../../shared/EditItemIcon';

const PropertyListItem = ({ property }) => {
    const { i18n } = useTranslation();
    return (
        <>
            <ListItemTitle itemCode={property} itemService={propertyNamesService}/>
            <h3 className="main__subtitle product__list-code">{property.propertyName}</h3>
            <h2 className="block__content product__list-title">{i18n.t('app.page.product.propertyItem.propertyType')}</h2>
            <p className="block__content product__list-content">
                {property.propertyType ?
                    i18n.t(propertiesService.getPropertyTypei18nCode(property))
                    :
                    <span className="product__list-content_warning">{i18n.t('app.page.product.notAssigned')}</span>}
            </p>
            <h2 className="block__content product__list-title">{i18n.t('app.page.product.propertyItem.categoryName')} </h2>
            <div className="block__content product__list-content">
                {property.categoryName ?
                    i18n.t(propertiesService.getPropertyCategoryi18nCode(property))
                    :
                    <span className="product__list-content_warning">{i18n.t('app.page.product.notAssigned')}</span>}
                {property.isVitamin ? 
                    <p className="block__content product__list-content">
                        {i18n.t(propertiesService.getPropertyVitaminTypei18nCode(property))}
                    </p>
                    :
                    null}
            </div>
            <div className="product__list-icons">
                {property.isDeleted ?
                    <RestoreItemIcon itemId={property.id} popupKey={POPUP_KEY_RESTORE_PROPERTY} />
                    :
                    <EditItemIcon pageUrl={`/product/property/${property.id}/`} />}
                <DeleteItemIcon 
                    itemId={property.id} 
                    itemDeleteService={propertyDeleteService} 
                    popupKey={POPUP_KEY_DELETE_PROPERTY} 
                />
            </div>
        </>
    );
};

export default PropertyListItem;
